/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Lastused_Never3Inputs */

const en_settings_reportingapikeys_lastused_never3 = /** @type {(inputs: Settings_Reportingapikeys_Lastused_Never3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Never`)
};

/**
* | output |
* | --- |
* | "Never" |
*
* @param {Settings_Reportingapikeys_Lastused_Never3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_lastused_never3 = /** @type {((inputs?: Settings_Reportingapikeys_Lastused_Never3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Lastused_Never3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_lastused_never3(inputs)
});
export { settings_reportingapikeys_lastused_never3 as "settings_reportingApiKeys_lastUsed_never" }